import React from 'react'
import "../assets/navbar.css"

export default function Footer() {
  return (
    <div className='footer'>Copright &copy; 23 | AMIMUN Club</div>
  )
}
